module.exports = __webpack_public_path__ + "static/requestHelpLogo-febb2248671853c302df3fd3f6794987.svg";